import React from 'react';
import Main from './components/main';

function App() {
  return (
    <Main />
  );
}

export default App;
